import React, {useEffect, useState} from 'react';
import './sponsors.scss'
interface Props {
	imagePath: string
	onBottom?: boolean
}

function Sponsors({imagePath, onBottom}: Props) {
	//const [sponsorScreenPath, setSponsorScreenPath] = useState(document.body.clientWidth>1000 ? imagePath: `mobile_${imagePath}`)
	const [sponsorScreenPath, setSponsorScreenPath] = useState(document.body.clientWidth>1000 ? imagePath: `${imagePath}`)
	window.addEventListener('resize', (e) => {
		// @ts-ignore
		//setSponsorScreenPath(e.target.document.body.clientWidth>1000 ? imagePath: `mobile_${imagePath}`)
		setSponsorScreenPath(e.target.document.body.clientWidth>1000 ? imagePath: `${imagePath}`)
	})
	
	return (
		<div className={'container sponsors'}>
			<div className={onBottom ? "position-bottom" : 'position-top'}>
				<img src={`/images/${sponsorScreenPath}`}/>
			</div>
		</div>
	);
}

export default Sponsors;